import { CLS_META } from "../lib/constants";
import { relativeTime, hasKorean, pickKoreanTitle, cleanText } from "../lib/utils";

const DIR_COLORS = {
  up:   "text-dir-escalation",
  down: "text-dir-deescalation",
};

const dirLabel = d => d === "up" ? "확전 요인" : d === "down" ? "진정 요인" : "중립";

export default function NewsCard({ article, onClick, onOverride }) {
  const { hed, hed_ko, src, publishedAt, time, dir, cls, reasoning, summary, summary_ko, altSources } = article;
  const displayTime = publishedAt ? relativeTime(publishedAt) : time;
  const cm = CLS_META[cls] || CLS_META.common;
  const showHITL = cls === "gun" || cls === "watershed" || cls === "notable";
  // gun/watershed: 한글 번역(summary_ko) 우선, 없으면 영어 원문. notable/common: 영어 원문.
  const isHighTier = cls === "gun" || cls === "watershed";
  const excerptRaw = (isHighTier && summary_ko) ? summary_ko : summary;
  const excerpt = cleanText(excerptRaw);

  return (
    <div
      onClick={() => onClick(article)}
      className="px-4 pt-5 pb-5 cursor-pointer"
    >
      {/* 상단: 방향+Tier+출처 (왼쪽) / HITL (오른쪽) */}
      <div className="flex items-center mb-3">
        <div className="flex-1 min-w-0">
          {/* 방향 · Tier */}
          <div className="flex items-center gap-2 mb-1">
            <span className={`text-meta font-bold tracking-wide uppercase ${DIR_COLORS[dir] || "text-text-tertiary"}`}>
              {dirLabel(dir)}
            </span>
            {cls && (
              <span className="text-meta font-bold tracking-wide uppercase" style={{ color: cm.color }}>
                {cm.label}
              </span>
            )}
          </div>
          {/* 출처 · 시간 */}
          <div className="flex gap-1.5 items-baseline flex-wrap">
            <span className="text-[11px] font-semibold text-text-secondary">{src}</span>
            {altSources?.map((s, i) => (
              <span key={i} className="text-[11px] text-text-tertiary font-medium">+{s.src}</span>
            ))}
            <span className="text-meta text-text-tertiary">· {displayTime}</span>
          </div>
        </div>
        {showHITL && onOverride && (
          <span className="flex gap-0 flex-shrink-0">
            <button
              onClick={e => { e.stopPropagation(); onOverride(article, "up"); }}
              className="min-w-[36px] min-h-[36px] flex items-center justify-center
                bg-transparent border-none text-text-tertiary text-[11px] opacity-40 hover:opacity-90 cursor-pointer"
              title="등급 상향"
            >↑</button>
            <button
              onClick={e => { e.stopPropagation(); onOverride(article, "down"); }}
              className="min-w-[36px] min-h-[36px] flex items-center justify-center
                bg-transparent border-none text-text-tertiary text-[11px] opacity-40 hover:opacity-90 cursor-pointer"
              title="등급 하향"
            >↓</button>
          </span>
        )}
      </div>

      {/* 한국어 헤드라인 */}
      <div className="text-[16px] font-bold text-text-primary leading-snug mb-1">
        {cleanText(pickKoreanTitle(hed_ko, hed))}
      </div>

      {/* 영문 헤드라인 — 한글 번역이 실제로 존재할 때만 표시 */}
      {hasKorean(hed_ko) && (
        <div className="text-sub text-text-tertiary/50 leading-snug">
          {cleanText(hed)}
        </div>
      )}

      {/* Why it matters — AI 해석. reasoning 없을 땐(짧은 페이월 매체 등) 블록 자체 생략. */}
      {reasoning && (
        <div className="mt-3">
          <div className="text-meta font-bold tracking-widest uppercase text-text-secondary mb-1.5">Why it matters</div>
          <div className="text-sub text-text-secondary leading-relaxed">{reasoning}</div>
        </div>
      )}

      {/* What it says — 원문 발췌. gun/watershed는 summary_ko(한글 번역), 그 외는 영어 원문. */}
      {excerpt.length >= 10 && (
        <div className="mt-3">
          <div className="text-meta font-bold tracking-widest uppercase text-text-secondary mb-1.5">What it says</div>
          <div className="text-sub text-text-secondary leading-relaxed">{excerpt}</div>
        </div>
      )}

      <div className="mx-4 mt-5 border-b border-white/10" />
    </div>
  );
}
